// src/firebaseConfig.ts
import {initializeApp} from "firebase/app";
import {getAuth, GoogleAuthProvider} from "firebase/auth";
import firebaseConfigData from "./firebaseConfig.json";
import {getEnvironment} from "./utils/environment";

const environment = getEnvironment();
const firebaseConfig = firebaseConfigData[environment];

const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);
const googleProvider = new GoogleAuthProvider();

export {firebaseApp, auth, googleProvider};
